import * as React from 'react'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, CircularProgress, DialogTitle } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import StepHeader from '@/components/CreateSpaceDialog/StepHeader'
import { BorderOutlinedBtn } from '@/components/Buttons'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    borderRadius: '12px',
    background: '#FFF',
    padding: '24px',
    maxWidth: '545px',
    width: '500px',
    overflow: 'hidden',
    boxShadow: '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export default function TeamDeleteConfirmationDialog({
  open,
  handleClose,
  loading,
  handleDelete,
  title,
  description,
  children,
  confirmBtnTitle = 'Remove',
}) {
  return (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          zIndex: 1,
          padding: 0,
        }}
      >
        <Box display="flex" justifyContent="flex-end" width="100%">
          <IconButton size="small" sx={{ height: '44px', width: '44px' }} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <StepHeader description={description} title={title} />
      </DialogTitle>
      <BackgroundMask
        icon={InfoOutlinedIcon}
        iconBgStyles={{ borderRadius: '50px', background: '#FEE4E2' }}
        iconStyles={{ color: '#D92D20' }}
      />

      <Box display="flex" flexDirection="column" gap="12px">
        {children ? children : null}
        <Box display="flex" gap="12px" width="100%">
          <BorderOutlinedBtn sx={{ width: '100%' }} onClick={handleClose}>
            Cancel
          </BorderOutlinedBtn>
          <Button
            color="error"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
            sx={{
              width: '100%',
              textTransform: 'none',
              borderRadius: '16px',
              border: '1px solid #D92D20',
              background: '#D92D20',
              boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
              '&:hover': {
                borderRadius: '16px',
                border: '1px solid #D92D20',
                background: '#D92D20',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
              },
            }}
            variant="contained"
            onClick={handleDelete}
          >
            {confirmBtnTitle}
          </Button>
        </Box>
      </Box>
    </BootstrapDialog>
  )
}

export function BackgroundMask({ icon: IconComponent, iconBgStyles = {}, maskStyles = {}, iconStyles = {} }) {
  return (
    <Box
      sx={{
        position: 'absolute',
        height: '217px',
        width: '217px',
        top: 0,
        left: 0,
        zIndex: 0,
        ...maskStyles,
      }}
    >
      <Box sx={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <BackgroundRadial />
      </Box>
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
        sx={{
          position: 'absolute',
          left: '25px',
          top: '25px',
          height: '48px',
          width: '48px',
          borderRadius: '10px',
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          ...iconBgStyles,
          zIndex: 1,
        }}
      >
        {IconComponent ? <IconComponent sx={{ color: '#344054', ...iconStyles }} /> : null}
      </Box>
    </Box>
  )
}
function BackgroundRadial() {
  return (
    <svg fill="none" height="216" viewBox="0 0 216 216" width="216" xmlns="http://www.w3.org/2000/svg">
      <mask
        height="336"
        id="mask0_762_20929"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="336"
        x="-120"
        y="-120"
      >
        <rect fill="url(#paint0_radial_762_20929)" height="336" transform="translate(-120 -120)" width="336" />
      </mask>
      <g mask="url(#mask0_762_20929)">
        <circle cx="48" cy="48" r="47.5" stroke="#EAECF0" />
        <circle cx="48" cy="48" r="47.5" stroke="#EAECF0" />
        <circle cx="48" cy="48" r="71.5" stroke="#EAECF0" />
        <circle cx="48" cy="48" r="95.5" stroke="#EAECF0" />
        <circle cx="48" cy="48" r="119.5" stroke="#EAECF0" />
        <circle cx="48" cy="48" r="143.5" stroke="#EAECF0" />
        <circle cx="48" cy="48" r="167.5" stroke="#EAECF0" />
      </g>
      <defs>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(168 168) rotate(90) scale(168 168)"
          gradientUnits="userSpaceOnUse"
          id="paint0_radial_762_20929"
          r="1"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}